<template>
  <div id="header" :style="style">
      <h1 :style="!mobile_two_lines && mobile ? 'margin-top: 10vh' : ''">{{ title }}</h1>
      <strong>{{ subtitle }}</strong>
  </div>
</template>

<script>
export default {
    name: 'Header',
    mounted() {
        console.log(this.background)
    },
    computed: {
        style () {
            return "background-image: url('"+ this.background + "');";
        }
    },
    data () {
        return {
            mobile: window.mobilecheck()
        }
    },
    props: {
        title: String,
        background: String,
        mobile_background: String,
        subtitle: String,
        mobile_two_lines: Boolean
    }
}
</script>

<style scoped>
    @import url("../assets/css/header.module.css");
</style>
